import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { Tooltip } from "primereact/tooltip";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";

import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import Textarea from "../../../Components/TextArea";
import NumberInput from "../../../Components/NumberInput";
import AlertModal from "../../../Components/AlertModal";
import PageLoader from "../../../Components/PageLoader";
import ToolModal from "./ToolModal";
import { baseURL } from "../../../Api/ApiConstant";
import { goToTop } from "../../../Components/goToTop";

import { ToolTypeList } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolTypeList";
import { ToolList } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolList";
import { ToolListData } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolListData";
import { StorageList } from "../../../Controllers/Types/HeyTraderTypes/Tools/StorageList";
import { CommonProjectType, mapCommonProjectType } from "../../../Controllers/Types/HeyTraderTypes/CommonProjectType";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { getToolList } from "../../../Controllers/Thunks/HeyTraderThunks";
import {
  deleteToolData,
  swapTools,
} from "../../../Api/HeyTraderService/ToolsService";
import { checkModelSelected, checkNumber } from "../../../Utils/Validator";
import { RootState } from "../../../Controllers/Store";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { Project } from "../../../Controllers/Types/Project/ProjectInterface";


const ToolItems: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const toast = useRef<Toast>(null);

  const loadingPage = "";
  const error = "";
  const [loading, setLoading] = useState<boolean>(false);
  const [customCreateLoading, setCustomCreateLoading] =
    useState<boolean>(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const [showAlertModal, setShowAlertModal] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  const [showToolModal, setShowToolModal] = useState<boolean>(false);
  const [toolListData, setToolListData] = useState<ToolListData | null>(null);
  const [toolTypeList, setToolTypeList] = useState<ToolTypeList[]>([]);
  const [expandedToolTypeId, setExpandedToolTypeId] = useState<number | null>(
    null
  );
  const [selectedToolData, setSelectedToolData] = useState<ToolList | null>(
    null
  );

  /* Tool location swap */
  const [toolSwapState, setToolSwapState] = useState<"On Site" | "Storage">(
    "On Site"
  );
  const [showToolSwapModal, setShowToolSwapModal] = useState<boolean>(false);
  const [quantity, setQuantity] = useState<number>(1);
  const [isDamaged, setIsDamaged] = useState<boolean>(false);
  const [damageNote, setDamageNote] = useState<string>("");

  const [siteError, setSiteError] = useState<string>("");
  const [storageError, setStorageError] = useState<string>("");
  const [quantityError, setQuantityError] = useState<string>("");
  const [damageNoteError, setDamageNoteError] = useState<string>("");

  // main project given
  const [mainProject, setSetMainProject] = useState<CommonProjectType | null>(null);


  /* Site */
  const [sitesData, setSitesData] = useState<CommonProjectType[]>([]);
  const [filteredSitesData, setFilteredSitesData] = useState<
    CommonProjectType[]
  >([]);
  const [selectedSiteData, setSelectedSiteData] =
    useState<CommonProjectType | null>(null);
  const [showSiteModal, setShowSiteModal] = useState<boolean>(false);
  const [siteSearchKey, setSiteSearchKey] = useState<string>("");

  /* Storage */
  const [storagesData, setStoragesData] = useState<StorageList[]>([]);
  const [filteredStoragesData, setFilteredStoragesData] = useState<
    StorageList[]
  >([]);
  const [selectedStorageData, setSelectedStorageData] =
    useState<StorageList | null>(null);
  const [showStorageModal, setShowStorageModal] = useState<boolean>(false);
  const [storageSearchKey, setStorageSearchKey] = useState<string>("");
  const [customStorageAddress, setCustomStorageAddress] = useState<string>("");
  const [customStorageAddressError, setCustomStorageAddressError] =
    useState<string>("");

  // database api collection data ass well



  useEffect(() => {
    if (location.state && location?.state?.mainProject) {
      const mainproject = location?.state?.mainProject as Project;
      if (mainproject && mainproject !== null) {
        const data: any = {
          project_id: mainproject?.project_id!,
          job_number: mainproject?.job_number!,
          project_type: mainproject?.project_type!,
          description: mainproject?.description!,
          status: mainproject?.status,
          full_address: mainproject?.address
        }
        setSetMainProject(mapCommonProjectType(data));
      }
      // need to set tools data
    } else {
      setSetMainProject(null);
    }
  }, [location?.state]);



  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data = useCanEdit("Tools", "add_tool");
  const edit_data = useCanEdit("Tools", "edit_tool");
  const delete_data = useCanEdit("Tools", "delete_tool");


  // for the resons
  const dispatch = useAppDispatch();

  const toolData = useAppSelector((state) => state.toolsList.toolList);

  const storageLists = useAppSelector(
    (state) => state.toolStorages.toolStorages
  );

  const projectList = useAppSelector(
    (state) => state.commonProjectList.projectList
  );

  useEffect(() => {
    dispatch(getToolList());
  }, []);

  useEffect(() => {
    if (location.state && location?.state?.toolListData) {
      const toold = location?.state?.toolListData as ToolListData;
      const collection = toolData.filter((e) => e.id === toold.id);
      if (collection && collection.length > 0) {
        setToolListData(collection[0] as ToolListData);
      }
      // need to set tools data
    } else {
      setToolListData(null);
    }
  }, [location?.state, toolData]);

  useEffect(() => {
    if (toolListData && toolListData !== null) {
      setToolTypeList(toolListData?.tool_type_list || []);

      if (
        toolListData?.tool_type_list &&
        toolListData?.tool_type_list?.length > 0
      ) {
        setExpandedToolTypeId(toolListData?.tool_type_list[0]?.id || null);
      }
    }
  }, [toolListData]);

  const handleToggleToolType = (toolType: ToolTypeList) => {
    setExpandedToolTypeId(
      expandedToolTypeId === toolType.id ? null : toolType.id!
    );
  };

  useEffect(() => {
    const fetchData = async () => {
      setSitesData(projectList);
    };
    fetchData();
  }, [projectList]);

  useEffect(() => {
    const fetchData = async () => {
      const filteredStorages = storageLists?.filter(
        (storage) => storage?.status === 1
      );
      if (filteredStorages && filteredStorages.length > 0) {
        setStoragesData(filteredStorages);
      } else {
        setStoragesData([]);
      }
    };
    fetchData();
  }, [storageLists]);

  /* *********************************** Tool ********************************** */
  const handleCloseToolModal = () => {
    setShowToolModal(false);
  };

  const handleEditTool = (toolData: ToolList, state: string) => {
    if (toolData?.editable === 0) {
      setShowAlertModal(true);
      setAlertMessage(
        `Can't ${state} because tool has been used, you can swap`
      );
    } else {
      setDataState("Edit");
      setSelectedToolData(toolData);
      setShowToolModal(true);
    }
  };

  const handleDeleteTool = (toolData: ToolList, state: string) => {
    const toolId = toolData?.tool_id;

    if (toolData?.editable === 0) {
      setShowAlertModal(true);
      setAlertMessage(
        `Can't ${state} because tool has been used, you can swap`
      );
    } else {
      confirmDialog({
        message: "Are you sure you want to delete this tool?",
        header: "Confirm the deletion",
        icon: "bi bi-info-circle",
        defaultFocus: "accept",
        acceptClassName: "p-button-danger",
        accept: () => deleteTool(toolId!),
        dismissableMask: true,
        resizable: false,
        draggable: false,
      });
    }
  };

  const deleteTool = async (toolId: number) => {
    const result = await deleteToolData(toolId);

    if (result.statusCode === 200) {
      dispatch(getToolList());

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Tool deleted successfully.",
          life: 3000,
        });
      }
    } else {
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error deleting the tool.",
          life: 3000,
        });
      }
    }
  };
  /* *************************************************************************** */

  /* *************************** Swap tool location **************************** */
  const handleCloseToolSwapModal = () => {
    setShowToolSwapModal(false);

    handleClearToolSwapFields();
    handleClearToolSwapError();
  };

  const handleClearToolSwapFields = () => {
    setSelectedSiteData(null);
    setSelectedStorageData(null);
    setQuantity(1);
    setIsDamaged(false);
    setDamageNote("");
  };

  const handleClearToolSwapError = () => {
    setSiteError("");
    setStorageError("");
    setQuantityError("");
    setDamageNoteError("");
  };

  const handleOpenToolSwapModal = (toolData: ToolList) => {
    setShowToolSwapModal(true);
    setSelectedToolData(toolData);

    setToolSwapState(toolData?.keep_in!);
    setQuantity(toolData?.tool_count || 0);
  };

  //   common validation for checking
  function checkCredentials(): boolean {
    const qty = checkNumber(quantity!, true, setQuantityError);
    if (toolSwapState === "On Site") {
      const site = checkModelSelected(
        selectedSiteData != null,
        true,
        setSiteError
      );
      return site && qty;
    } else {
      const storage = checkModelSelected(
        selectedStorageData != null,
        true,
        setStorageError
      );
      return storage && qty;
    }
  }

  // swap functions for tools.
  const handleSwapToolLocation = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await swapTools(
        toolSwapState,
        (selectedSiteData === null) ? null : selectedSiteData?.project_id!,
        (selectedStorageData === null) ? null : selectedStorageData?.id!,
        quantity,
        (isDamaged ? 1 : 0),
        damageNote,
        selectedToolData?.data_id!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getToolList());
        setLoading(false);

        handleCloseToolSwapModal();

        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Tool swapped successfully.",
            life: 3000,
          });
        }
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Failed",
            detail: "There was an error swapping the tool.",
            life: 3000,
          });
        }
      }
    }
  };

  const toolSwapModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Swap tool location</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseToolSwapModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const toolSwapModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={handleCloseToolSwapModal}
      />

      <Button
        label="Swap"
        onClick={handleSwapToolLocation}
        loading={loading}
        className="custom_btn primary"
        disabled={
          (toolSwapState === "On Site" && selectedSiteData === null) ||
          (toolSwapState === "Storage" && selectedStorageData === null)
        }
      />
    </div>
  );

  const handleSwitchToolSwapState = (state: "On Site" | "Storage") => {
    setToolSwapState(state);
  };

  const handleQuantityChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setQuantity(e.value);
    }
  };

  const handleChangeIsDamaged = (e: CheckboxChangeEvent) => {
    setIsDamaged(e.checked || false);

    if (e.checked === false) {
      setDamageNote("");
      setDamageNoteError("");
    }
  };
  /* *************************************************************************** */

  /* *********************************** Site ********************************** */
  useEffect(() => {
    if (sitesData && sitesData?.length > 0) {
      const filteredSites = sitesData.filter(
        (site) =>
          (site
            ?.job_number!.toLowerCase()
            .includes(siteSearchKey.toLowerCase()) ||
            site
              ?.address!.toLowerCase()
              .includes(siteSearchKey.toLowerCase())) &&
          site?.project_id !== selectedToolData?.project_id
      );
      setFilteredSitesData(filteredSites);
    } else {
      setFilteredSitesData([]);
    }
  }, [sitesData, siteSearchKey, selectedToolData]);

  const handleCloseSiteModal = () => {
    setShowSiteModal(false);
    setSiteSearchKey("");
  };

  const handleAddSite = () => {
    setShowSiteModal(true);
  };

  const handleSelectSite = (site: CommonProjectType) => {
    setSelectedSiteData(site);

    setTimeout(() => {
      handleCloseSiteModal();
    }, 200);
  };
  /* *************************************************************************** */

  /* ********************************* Storage ********************************* */
  useEffect(() => {
    if (storagesData && storagesData?.length > 0) {
      const filteredStorages = storagesData.filter(
        (storage) =>
          storage
            ?.storage_name!.toLowerCase()
            .includes(storageSearchKey.toLowerCase()) &&
          storage?.id !== selectedToolData?.storage_id
      );
      setFilteredStoragesData(filteredStorages);
    } else {
      setFilteredStoragesData([]);
    }
  }, [storagesData, storageSearchKey, selectedToolData]);

  const handleCloseStorageModal = () => {
    setShowStorageModal(false);
    setStorageSearchKey("");

    handleClearCustomStorageFields();
  };

  const handleClearCustomStorageFields = () => {
    setCustomStorageAddress("");
    setCustomStorageAddressError("");
  };

  const handleAddStorage = () => {
    setShowStorageModal(true);
  };

  const handleSelectStorage = (storage: StorageList) => {
    setSelectedStorageData(storage);

    setTimeout(() => {
      handleCloseStorageModal();
    }, 200);
  };

  const handleCreateCustomStorage = (e: React.FormEvent) => {
    e.preventDefault();
    setCustomCreateLoading(true);

    try {
      setTimeout(() => {
        setCustomCreateLoading(false);
        handleClearCustomStorageFields();
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Storage created successfully.",
            life: 3000,
          });
        }
      }, 500);
    } catch (error) {
      setLoading(false);
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating the storage.",
          life: 3000,
        });
      }
    }
  };
  /* *************************************************************************** */

  /* **************************** Common functions ***************************** */
  const handleSuccess = (message: string) => {
    setSuccessMessage(message);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <Tooltip target=".tool_modify_btn" />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">
            <div className="page_breadcrumb_area">
              <ul className="page_breadcrumb">
                {(mainProject !== null) && (
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-2)}>
                    {mainProject?.job_number}: {mainProject?.address}
                  </li>
                )}
                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>Tools</li>
                <li className="page_breadcrumb_item active">
                  {toolListData?.category_name}
                </li>
              </ul>

              <button className="back_btn p-ripple" onClick={goBack}>
                <i className="bi bi-arrow-left me-2"></i>
                Back
                <Ripple />
              </button>
            </div>

            <div className="page_main_content_section">
              {toolTypeList && toolTypeList?.length > 0 ? (
                <div className="tool_list_data_area">
                  {toolTypeList?.map((toolType) => {
                    const isExpanded = expandedToolTypeId === toolType.id;
                    return (
                      <div
                        key={toolType?.id}
                        className={`tool_list_data_container ${isExpanded && "expanded"}`}
                      >
                        <div
                          className={`tool_list_data_header p-ripple ${isExpanded && "expanded"}`}
                          onClick={() => handleToggleToolType(toolType)}
                        >
                          <div className="tool_list_detail">
                            <img
                              src={baseURL + toolType?.path}
                              alt={toolType?.type_name}
                            />
                            <span>{toolType?.type_name}</span>
                          </div>

                          <div className="tool_list_view">
                            <span>
                              {String(toolType?.tool_count).padStart(2, "0")}
                            </span>
                            <i
                              className="bi bi-chevron-down"
                              onClick={() => handleToggleToolType(toolType)}
                            ></i>
                          </div>
                          <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                        </div>

                        <div className={`tool_list_data_body ${isExpanded && "show"}`}>
                          <div className="table-responsive">
                            <table className="table table-sm tool_list_table mb-0">
                              {toolType?.tools && (mainProject === null ? toolType?.tools?.length > 0 : toolType?.tools?.filter(item => item?.project_id === mainProject.project_id)?.length > 0) ? (
                                <tbody>
                                  {toolType?.tools?.filter((e) => (mainProject === null) ? true : e.project_id === mainProject.project_id).map((tool, index) => {
                                    return (
                                      <tr
                                        key={`tool_${toolType?.type_name!}_${index}`}
                                        className="tool_list_table_row"
                                      >
                                        <td
                                          style={{ width: "20%" }}
                                          className="brand_column"
                                        >
                                          <span
                                            style={{ color: tool?.brand_color }}
                                          >
                                            {tool?.brand_name}
                                          </span>
                                        </td>

                                        <td
                                          style={{ width: "55%" }}
                                          className="location_column"
                                        >
                                          {(mainProject === null) && (<span>
                                            {tool?.tool_name! + ` (${tool?.location_name})`}
                                          </span>)}

                                          {(mainProject !== null) && (
                                            <span>
                                              {tool?.tool_name!}
                                            </span>
                                          )}
                                        </td>

                                        <td style={{ width: "5%" }}>
                                          <span>
                                            {String(tool?.tool_count).padStart(2, "0")}
                                          </span>
                                        </td>

                                        <td style={{ width: "20%" }}>
                                          <div className="table_action_btn_area">

                                            {(add_data) && (
                                              <button
                                                className="table_action_btn tool_modify_btn p-ripple"
                                                onClick={() => handleOpenToolSwapModal(tool)}
                                              >
                                                {/* <i className="bi bi-arrow-left-right"></i> */}
                                                Swap
                                                <Ripple />
                                              </button>
                                            )}

                                            {(edit_data) && (
                                              <button
                                                className="table_action_btn tool_modify_btn p-ripple"
                                                // disabled={tool?.editable === 0}
                                                onClick={() => handleEditTool(tool, "edit")}
                                              >
                                                Edit
                                                <Ripple />
                                              </button>
                                            )}

                                            {(delete_data) && (
                                              <button
                                                className="table_action_btn tool_modify_btn p-ripple"
                                                // disabled={tool?.editable === 0}
                                                onClick={() => handleDeleteTool(tool, "delete")}
                                              >
                                                Delete
                                                <Ripple />
                                              </button>
                                            )}
                                          </div>
                                        </td>
                                      </tr>
                                    )
                                  })}
                                </tbody>
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan={3} className="text_empty text-center border-0">
                                      <i className="bi bi-exclamation-circle me-2"></i>
                                      No tools available!
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                            </table>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                <NoDataCreated message={`No tools found`} />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Tool modal */}
      <ToolModal
        isOpen={showToolModal}
        dataState={dataState}
        onClose={handleCloseToolModal}
        onSuccess={handleSuccess}
        toast={toast}
        toolData={selectedToolData}
      />
      {/*  */}

      {/* Tool location swap */}
      <Dialog
        visible={showToolSwapModal}
        headerClassName="custom_modal_header"
        header={toolSwapModalHeader}
        footer={toolSwapModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseToolSwapModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Current location */}
              {selectedToolData && selectedToolData !== null && (
                <div className="col-12">
                  <h6 className="too_info_label">
                    Current location:{" "}
                    <span>
                      {selectedToolData?.location_name +
                        ` (${selectedToolData?.keep_in})`}
                    </span>
                  </h6>
                </div>
              )}

              {/* Tool swap state */}
              <div className="col-12">
                <div className="add_data_switch_btn_area">
                  <button
                    className={`add_data_switch_btn p-ripple ${toolSwapState === "On Site" && "active"
                      }`}
                    type="button"
                    role="tab"
                    onClick={() => handleSwitchToolSwapState("On Site")}
                  >
                    On Site
                    <Ripple />
                  </button>

                  <button
                    className={`add_data_switch_btn p-ripple ${toolSwapState === "Storage" && "active"
                      }`}
                    type="button"
                    role="tab"
                    onClick={() => handleSwitchToolSwapState("Storage")}
                  >
                    Storage
                    <Ripple />
                  </button>
                </div>
              </div>

              {toolSwapState === "On Site" ? (
                <React.Fragment>
                  {/* Site */}
                  <div className="col-12">
                    <div className="page_form_group">
                      <label
                        htmlFor="site"
                        className="custom_form_label is_required"
                      >
                        Site
                      </label>
                      <div className="input_with_button_area">
                        <InputText
                          key={"site_swap"}
                          id="site"
                          value={selectedSiteData && selectedSiteData?.job_number + " - " + selectedSiteData?.address}
                          className="custom_form_input has_add_value"
                          placeholder="Click to select the site."
                          readOnly={true}
                          autoComplete="off"
                          onClick={handleAddSite}
                        />
                        <button
                          className="add_value_btn p-ripple"
                          onClick={handleAddSite}
                        >
                          {selectedSiteData === null ? (
                            <React.Fragment>
                              <i className="bi bi-plus-lg"></i>
                              <span>Add</span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <i className="bi bi-pencil-square"></i>
                              <span>Change</span>
                            </React.Fragment>
                          )}
                          <Ripple />
                        </button>
                      </div>

                      {siteError && (
                        <small className="form_error_msg">{siteError}</small>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ) : toolSwapState === "Storage" ? (
                <React.Fragment>
                  {/* Storage */}
                  <div className="col-12">
                    <div className="page_form_group">
                      <label
                        htmlFor="storage"
                        className="custom_form_label is_required"
                      >
                        Storage
                      </label>
                      <div className="input_with_button_area">
                        <InputText
                          key={"storage_swap"}
                          id="storage"
                          value={selectedStorageData && selectedStorageData?.storage_name}
                          className="custom_form_input has_add_value"
                          placeholder="Click to select the storage."
                          readOnly={true}
                          autoComplete="off"
                          onClick={handleAddStorage}
                        />
                        <button
                          className="add_value_btn p-ripple"
                          onClick={handleAddStorage}
                        >
                          {selectedStorageData === null ? (
                            <React.Fragment>
                              <i className="bi bi-plus-lg"></i>
                              <span>Add</span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <i className="bi bi-pencil-square"></i>
                              <span>Change</span>
                            </React.Fragment>
                          )}
                          <Ripple />
                        </button>
                      </div>

                      {storageError && (
                        <small className="form_error_msg">{storageError}</small>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              ) : null}

              {/* Quantity */}
              <div className="col-12">
                <NumberInput
                  inputId="quantity"
                  label="Quantity"
                  labelHtmlFor="quantity"
                  placeholder="Enter quantity"
                  onChange={handleQuantityChange}
                  value={quantity}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  error={quantityError}
                />
              </div>

              {/* Damage */}
              <div className="col-12">
                <div className="page_form_group mb-0">
                  <div className="custom_form_check_group">
                    <Checkbox
                      inputId={`isDamaged`}
                      onChange={handleChangeIsDamaged}
                      checked={isDamaged}
                    ></Checkbox>
                    <label
                      htmlFor={`isDamaged`}
                      className={`custom_form_check_label`}
                    >
                      Damage
                    </label>
                  </div>
                </div>
              </div>

              {isDamaged && (
                <div className="col-12 mt-3">
                  <Textarea
                    id="damageNote"
                    label="Note"
                    labelHtmlFor="damageNote"
                    required={false}
                    value={damageNote}
                    placeholder="Note"
                    inputAutoFocus={isDamaged}
                    onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDamageNote(e.target.value)}
                    error={damageNoteError}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Site modal */}
      <Dialog
        visible={showSiteModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseSiteModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"siteSearchKey"}
                id="siteSearchKey"
                value={siteSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSiteSearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search site by job number/address"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {siteSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setSiteSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseSiteModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body">
            {filteredSitesData && filteredSitesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredSitesData?.map((site) => (
                    <div
                      key={site?.project_id}
                      className={`data_select_option p-ripple ${site?.project_id === selectedSiteData?.project_id && "selected"}`}
                      onClick={() => handleSelectSite(site)}
                    >
                      {site?.job_number + " - " + site?.address}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Storage modal */}
      <Dialog
        visible={showStorageModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseStorageModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"storageSearchKey"}
                id="storageSearchKey"
                value={storageSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setStorageSearchKey(e.target.value)}
                className="custom_form_input data_search_input"
                placeholder="Search storage by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {storageSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setStorageSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseStorageModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {filteredStoragesData && filteredStoragesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredStoragesData?.map((storage) => (
                    <div
                      key={storage?.id}
                      className={`data_select_option p-ripple ${storage?.id === selectedStorageData?.id && "selected"}`}
                      onClick={() => handleSelectStorage(storage)}
                    >
                      {storage?.storage_name}
                      <Ripple pt={{ root: { style: { background: "rgba(164, 96, 253, 0.2)" } } }} />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                id="customStorageAddress"
                value={customStorageAddress}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCustomStorageAddress(e.target.value)}
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter storage address"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomStorage}
                disabled={customCreateLoading || customStorageAddress === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customStorageAddressError && (
              <small className="form_error_msg">
                {customStorageAddressError}
              </small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Alert modal */}
      <AlertModal
        isOpen={showAlertModal}
        onClose={() => setShowAlertModal(false)}
        message={alertMessage}
      />
      {/*  */}

      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}
    </React.Fragment>
  );
};

export default ToolItems;
